export function generateUpdatePayload(previous, target) {
    const deleted = Object.keys(previous).filter(
        k => previous[k] !== undefined && target[k] === undefined
    );
    return deleted.length > 0
        ? {
              ...target,
              deleted
          }
        : target;
}

export function mergeUpdatePayloads(payloads = []) {
    const { fields, deleted } = payloads.reduce(
        (obj, { deleted = [], ...fields }) => {
            obj.deleted = [...obj.deleted, ...deleted];
            obj.fields = { ...obj.fields, ...fields };

            return obj;
        },
        { fields: {}, deleted: [] }
    );
    return {
        ...fields,
        deleted
    };
}
